import { useSession } from '@/features/auth/session-context';
import { CONSENT_TEMPLATE_PERMISSIONS } from './types';

/**
 * What the active role may do with consent templates (RL-908): doctors and
 * clinic managers write, edit and retire them (`consent_templates:manage`);
 * only a doctor approves (`consent_templates:approve`). The API lets the
 * author approve their own draft, so nothing here stops that.
 */
export function useConsentTemplateAccess() {
  const { hasPermission } = useSession();
  const manage = hasPermission(CONSENT_TEMPLATE_PERMISSIONS.manage);
  const approve = hasPermission(CONSENT_TEMPLATE_PERMISSIONS.approve);
  return { canView: manage || approve, canManage: manage, canApprove: approve };
}
